import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "view-news",
    style: {
      backgroundColor: _vm.formData.bgColor
    }
  }, [_c("main", {
    staticClass: "body"
  }, [_c("div", {
    staticClass: "title",
    style: {
      color: _vm.formData.newsTitleColor,
      fontSize: _vm.formData.newsTitleFontSize + "px"
    }
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.formData.newsTitle[_vm.defaultLangId]) + " ")]), _vm.formData.newsMoreVisible ? _c("span", {
    staticClass: "more",
    style: {
      color: _vm.formData.moreTextColor,
      fontSize: _vm.formData.moreTextSize + "px"
    }
  }, [_vm._v(_vm._s(_vm.formData.moreText[_vm.defaultLangId]))]) : _vm._e()]), _c("ul", {
    staticClass: "news"
  }, _vm._l(_vm.news.slice(0, _vm.formData.mobileShowNum), function (item, i) {
    return _c("li", {
      key: item.id,
      ref: "news-item",
      refInFor: true,
      staticClass: "news-item",
      style: {
        color: _vm.formData.newsListTitleColor,
        backgroundColor: _vm.formData.newsListMobileBg
      }
    }, [_c("span", {
      staticClass: "name",
      style: {
        fontSize: _vm.formData.newsListTitleFontSize + "px"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _vm.formData.showdate ? _c("div", {
      staticClass: "date"
    }, [_vm._v(" " + _vm._s(_vm.getPublishDate(item.publishTime)) + " ")]) : _vm._e()]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };